enum Type {
  crypto = "crypto",
  fiat = "fiat",
  metal = "metal",
}

export interface Currency {
  code: string;
  countries: string[];
  decimalDigits: number;
  iconName?: string;
  locale?: string;
  name: string;
  namePlural: string;
  rounding: number;
  symbol: string;
  symbolNative: string;
  type: Type;
}

export const currencies: Currency[] = [
  {
    code: "AED",
    countries: ["AE"],
    decimalDigits: 2,
    locale: "ar-AE",
    name: "United Arab Emirates Dirham",
    namePlural: "UAE dirhams",
    rounding: 0,
    symbol: "AED",
    symbolNative: "د.إ",
    type: Type.fiat,
  },
  {
    code: "AFN",
    countries: ["AF"],
    decimalDigits: 0,
    locale: "ps-AF",
    name: "Afghan Afghani",
    namePlural: "Afghan Afghanis",
    rounding: 0,
    symbol: "Af",
    symbolNative: "؋",
    type: Type.fiat,
  },
  {
    code: "ALL",
    countries: ["AL"],
    decimalDigits: 0,
    locale: "sq-AL",
    name: "Albanian Lek",
    namePlural: "Albanian lekë",
    rounding: 0,
    symbol: "ALL",
    symbolNative: "Lek",
    type: Type.fiat,
  },
  {
    code: "AMD",
    countries: ["AM"],
    decimalDigits: 0,
    locale: "hy-AM",
    name: "Armenian Dram",
    namePlural: "Armenian drams",
    rounding: 0,
    symbol: "AMD",
    symbolNative: "դր.",
    type: Type.fiat,
  },
  {
    code: "ANG",
    countries: ["CW", "SX"],
    decimalDigits: 2,
    iconName: "ang",
    locale: "nl",
    name: "NL Antillean Guilder",
    namePlural: "NL Antillean Guilders",
    rounding: 0,
    symbol: "ƒ",
    symbolNative: "NAƒ",
    type: Type.fiat,
  },
  {
    code: "AOA",
    countries: ["AO"],
    decimalDigits: 2,
    iconName: "aoa",
    locale: "pt",
    name: "Angolan Kwanza",
    namePlural: "Angolan Kwanza",
    rounding: 0,
    symbol: "Kz",
    symbolNative: "Kz",
    type: Type.fiat,
  },
  {
    code: "ARS",
    countries: ["AR"],
    decimalDigits: 2,
    locale: "es-AR",
    name: "Argentine Peso",
    namePlural: "Argentine pesos",
    rounding: 0,
    symbol: "AR$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "AUD",
    countries: ["AU", "CC", "CX", "HM", "KI", "NF", "NR", "TV"],
    decimalDigits: 2,
    locale: "en-AU",
    name: "Australian Dollar",
    namePlural: "Australian dollars",
    rounding: 0,
    symbol: "AU$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "AWG",
    countries: ["AW"],
    decimalDigits: 2,
    iconName: "awg",
    locale: "nl",
    name: "Aruban Florin",
    namePlural: "Aruban Florin",
    rounding: 0,
    symbol: "Afl.",
    symbolNative: "Afl.",
    type: Type.fiat,
  },
  {
    code: "AZN",
    countries: ["AZ"],
    decimalDigits: 2,
    locale: "az-Cyrl-AZ",
    name: "Azerbaijani Manat",
    namePlural: "Azerbaijani manats",
    rounding: 0,
    symbol: "man.",
    symbolNative: "ман.",
    type: Type.fiat,
  },
  {
    code: "BAM",
    countries: ["BA"],
    decimalDigits: 2,
    locale: "bs-BA",
    name: "Bosnia-Herzegovina Convertible Mark",
    namePlural: "Bosnia-Herzegovina convertible marks",
    rounding: 0,
    symbol: "KM",
    symbolNative: "KM",
    type: Type.fiat,
  },
  {
    code: "BBD",
    countries: ["BB"],
    decimalDigits: 2,
    iconName: "bbd",
    locale: "en",
    name: "Barbadian Dollar",
    namePlural: "Barbadian Dollars",
    rounding: 0,
    symbol: "Bds$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "BDT",
    countries: ["BD"],
    decimalDigits: 2,
    locale: "bn-BD",
    name: "Bangladeshi Taka",
    namePlural: "Bangladeshi takas",
    rounding: 0,
    symbol: "Tk",
    symbolNative: "৳",
    type: Type.fiat,
  },
  {
    code: "BGN",
    countries: ["BG"],
    decimalDigits: 2,
    locale: "bg-BG",
    name: "Bulgarian Lev",
    namePlural: "Bulgarian leva",
    rounding: 0,
    symbol: "BGN",
    symbolNative: "лв.",
    type: Type.fiat,
  },
  {
    code: "BHD",
    countries: ["BH"],
    decimalDigits: 3,
    locale: "ar-BH",
    name: "Bahraini Dinar",
    namePlural: "Bahraini dinars",
    rounding: 0,
    symbol: "BD",
    symbolNative: "د.ب.‏",
    type: Type.fiat,
  },
  {
    code: "BIF",
    countries: ["BI"],
    decimalDigits: 0,
    locale: "fr-BI",
    name: "Burundian Franc",
    namePlural: "Burundian francs",
    rounding: 0,
    symbol: "FBu",
    symbolNative: "FBu",
    type: Type.fiat,
  },
  {
    code: "BMD",
    countries: ["BM"],
    decimalDigits: 2,
    iconName: "bmd",
    locale: "en",
    name: "Bermudan Dollar",
    namePlural: "Bermudan Dollars",
    rounding: 0,
    symbol: "BD$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "BND",
    countries: ["BN"],
    decimalDigits: 2,
    locale: "ms-BN",
    name: "Brunei Dollar",
    namePlural: "Brunei dollars",
    rounding: 0,
    symbol: "BN$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "BOB",
    countries: ["BO"],
    decimalDigits: 2,
    locale: "es-BO",
    name: "Bolivian Boliviano",
    namePlural: "Bolivian bolivianos",
    rounding: 0,
    symbol: "Bs",
    symbolNative: "Bs",
    type: Type.fiat,
  },
  {
    code: "BRL",
    countries: ["BR"],
    decimalDigits: 2,
    locale: "pt-BR",
    name: "Brazilian Real",
    namePlural: "Brazilian reals",
    rounding: 0,
    symbol: "R$",
    symbolNative: "R$",
    type: Type.fiat,
  },
  {
    code: "BSD",
    countries: ["BS"],
    decimalDigits: 2,
    iconName: "bsd",
    locale: "en",
    name: "Bahamian Dollar",
    namePlural: "Bahamian Dollars",
    rounding: 0,
    symbol: "B$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "BTN",
    countries: ["BT"],
    decimalDigits: 2,
    iconName: "btn",
    locale: "dz",
    name: "Bhutanese Ngultrum",
    namePlural: "Bhutanese Ngultrum",
    rounding: 0,
    symbol: "Nu.",
    symbolNative: "Nu.",
    type: Type.fiat,
  },
  {
    code: "BWP",
    countries: ["BW", "ZW"],
    decimalDigits: 2,
    locale: "en-BW",
    name: "Botswanan Pula",
    namePlural: "Botswanan pulas",
    rounding: 0,
    symbol: "BWP",
    symbolNative: "P",
    type: Type.fiat,
  },
  {
    code: "BYN",
    countries: [],
    decimalDigits: 2,
    locale: "be-BY",
    name: "Belarusian ruble",
    namePlural: "Belarusian rubles",
    rounding: 0,
    symbol: "Br",
    symbolNative: "Br",
    type: Type.fiat,
  },
  {
    code: "BYR",
    countries: ["BY"],
    decimalDigits: 0,
    name: "Belarusian Ruble",
    namePlural: "Belarusian rubles",
    rounding: 0,
    symbol: "BYR",
    symbolNative: "BYR",
    type: Type.fiat,
  },
  {
    code: "BZD",
    countries: ["BZ"],
    decimalDigits: 2,
    locale: "en-BZ",
    name: "Belize Dollar",
    namePlural: "Belize dollars",
    rounding: 0,
    symbol: "BZ$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "CAD",
    countries: ["CA"],
    decimalDigits: 2,
    locale: "en-CA",
    name: "Canadian Dollar",
    namePlural: "Canadian dollars",
    rounding: 0,
    symbol: "CA$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "CDF",
    countries: ["CD"],
    decimalDigits: 2,
    locale: "fr-CD",
    name: "Congolese Franc",
    namePlural: "Congolese francs",
    rounding: 0,
    symbol: "CDF",
    symbolNative: "FrCD",
    type: Type.fiat,
  },
  {
    code: "CHF",
    countries: ["CH", "LI"],
    decimalDigits: 2,
    locale: "de-LI",
    name: "Swiss Franc",
    namePlural: "Swiss francs",
    rounding: 0,
    symbol: "CHF",
    symbolNative: "CHF",
    type: Type.fiat,
  },
  {
    code: "CLF",
    countries: ["CL"],
    decimalDigits: 2,
    name: "Unidad de Fomento",
    namePlural: "Unidad de Fomentos",
    rounding: 0,
    symbol: "UF",
    symbolNative: "UF",
    type: Type.fiat,
  },
  {
    code: "CLP",
    countries: ["CL"],
    decimalDigits: 0,
    locale: "es-CL",
    name: "Chilean Peso",
    namePlural: "Chilean pesos",
    rounding: 0,
    symbol: "CL$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "CNY",
    countries: ["CN"],
    decimalDigits: 2,
    locale: "zh-CN",
    name: "Chinese Yuan",
    namePlural: "Chinese yuan",
    rounding: 0,
    symbol: "CN¥",
    symbolNative: "CN¥",
    type: Type.fiat,
  },
  {
    code: "COP",
    countries: ["CO"],
    decimalDigits: 0,
    locale: "es-CO",
    name: "Colombian Peso",
    namePlural: "Colombian pesos",
    rounding: 0,
    symbol: "CO$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "CRC",
    countries: ["CR"],
    decimalDigits: 0,
    locale: "es-CR",
    name: "Costa Rican Colón",
    namePlural: "Costa Rican colóns",
    rounding: 0,
    symbol: "₡",
    symbolNative: "₡",
    type: Type.fiat,
  },
  {
    code: "CUC",
    countries: ["CU"],
    decimalDigits: 2,
    iconName: "cuc",
    locale: "es",
    name: "Cuban Convertible Peso",
    namePlural: "Cuban Convertible Peso",
    rounding: 0,
    symbol: "CUC$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "CUP",
    countries: ["CU"],
    decimalDigits: 2,
    iconName: "cup",
    name: "Cuban Peso",
    namePlural: "Cuban Peso",
    rounding: 0,
    symbol: "$MN",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "CVE",
    countries: ["CV"],
    decimalDigits: 2,
    locale: "kea-CV",
    name: "Cape Verdean Escudo",
    namePlural: "Cape Verdean escudos",
    rounding: 0,
    symbol: "CV$",
    symbolNative: "CV$",
    type: Type.fiat,
  },
  {
    code: "CZK",
    countries: ["CZ"],
    decimalDigits: 2,
    locale: "cs-CZ",
    name: "Czech Republic Koruna",
    namePlural: "Czech Republic korunas",
    rounding: 0,
    symbol: "Kč",
    symbolNative: "Kč",
    type: Type.fiat,
  },
  {
    code: "DJF",
    countries: ["DJ"],
    decimalDigits: 0,
    locale: "fr-DJ",
    name: "Djiboutian Franc",
    namePlural: "Djiboutian francs",
    rounding: 0,
    symbol: "Fdj",
    symbolNative: "Fdj",
    type: Type.fiat,
  },
  {
    code: "DKK",
    countries: ["DK", "FO", "GL"],
    decimalDigits: 2,
    locale: "da-DK",
    name: "Danish Krone",
    namePlural: "Danish kroner",
    rounding: 0,
    symbol: "Dkr",
    symbolNative: "kr",
    type: Type.fiat,
  },
  {
    code: "DOP",
    countries: ["DO"],
    decimalDigits: 2,
    locale: "es-DO",
    name: "Dominican Peso",
    namePlural: "Dominican pesos",
    rounding: 0,
    symbol: "RD$",
    symbolNative: "RD$",
    type: Type.fiat,
  },
  {
    code: "DZD",
    countries: ["DZ"],
    decimalDigits: 2,
    locale: "ar-DZ",
    name: "Algerian Dinar",
    namePlural: "Algerian dinars",
    rounding: 0,
    symbol: "DA",
    symbolNative: "د.ج.‏",
    type: Type.fiat,
  },
  {
    code: "EGP",
    countries: ["EG", "PS"],
    decimalDigits: 2,
    locale: "ar-EG",
    name: "Egyptian Pound",
    namePlural: "Egyptian pounds",
    rounding: 0,
    symbol: "EGP",
    symbolNative: "ج.م.‏",
    type: Type.fiat,
  },
  {
    code: "ERN",
    countries: ["ER"],
    decimalDigits: 2,
    locale: "ti-ER",
    name: "Eritrean Nakfa",
    namePlural: "Eritrean nakfas",
    rounding: 0,
    symbol: "Nfk",
    symbolNative: "Nfk",
    type: Type.fiat,
  },
  {
    code: "ETB",
    countries: ["ET"],
    decimalDigits: 2,
    locale: "am-ET",
    name: "Ethiopian Birr",
    namePlural: "Ethiopian birrs",
    rounding: 0,
    symbol: "Br",
    symbolNative: "Br",
    type: Type.fiat,
  },
  {
    code: "EUR",
    countries: [
      "AD",
      "AT",
      "AX",
      "BE",
      "BL",
      "CP",
      "CY",
      "DE",
      "EA",
      "EE",
      "ES",
      "EU",
      "FI",
      "FR",
      "FX",
      "GF",
      "GP",
      "GR",
      "IC",
      "IE",
      "IT",
      "LT",
      "LU",
      "LV",
      "MC",
      "ME",
      "MF",
      "MQ",
      "MT",
      "NL",
      "PM",
      "PT",
      "RE",
      "SI",
      "SK",
      "SM",
      "TF",
      "VA",
      "XK",
      "YT",
      "ZW",
    ],
    decimalDigits: 2,
    locale: "ca",
    name: "Euro",
    namePlural: "Euros",
    rounding: 0,
    symbol: "€",
    symbolNative: "€",
    type: Type.fiat,
  },
  {
    code: "FJD",
    countries: ["FJ"],
    decimalDigits: 2,
    iconName: "fjd",
    locale: "en",
    name: "Fijian Dollar",
    namePlural: "Fijian Dollar",
    rounding: 0,
    symbol: "FJ$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "FKP",
    countries: ["FK"],
    decimalDigits: 2,
    iconName: "fkp",
    name: "Falkland Islands Pound",
    namePlural: "Falkland Islands Pound",
    rounding: 0,
    symbol: "FK£",
    symbolNative: "£",
    type: Type.fiat,
  },
  {
    code: "GBP",
    countries: ["GB", "GG", "GS", "IM", "JE", "TA", "UK", "ZW"],
    decimalDigits: 2,
    locale: "en",
    name: "British Pound Sterling",
    namePlural: "British pounds sterling",
    rounding: 0,
    symbol: "£",
    symbolNative: "£",
    type: Type.fiat,
  },
  {
    code: "GEL",
    countries: ["GE"],
    decimalDigits: 2,
    locale: "ka-GE",
    name: "Georgian Lari",
    namePlural: "Georgian laris",
    rounding: 0,
    symbol: "GEL",
    symbolNative: "GEL",
    type: Type.fiat,
  },
  {
    code: "GGP",
    countries: [],
    decimalDigits: 2,
    name: "Guernsey pound",
    namePlural: "Guernsey pounds",
    rounding: 0,
    symbol: "£",
    symbolNative: "£",
    type: Type.fiat,
  },
  {
    code: "GHS",
    countries: ["GH"],
    decimalDigits: 2,
    locale: "ak-GH",
    name: "Ghanaian Cedi",
    namePlural: "Ghanaian cedis",
    rounding: 0,
    symbol: "GH₵",
    symbolNative: "GH₵",
    type: Type.fiat,
  },
  {
    code: "GIP",
    countries: ["GI"],
    decimalDigits: 2,
    iconName: "gip",
    locale: "en",
    name: "Gibraltar Pound",
    namePlural: "Gibraltar Pounds",
    rounding: 0,
    symbol: "£",
    symbolNative: "£",
    type: Type.fiat,
  },
  {
    code: "GMD",
    countries: ["GM"],
    decimalDigits: 2,
    iconName: "gmd",
    locale: "en",
    name: "Gambian Dalasi",
    namePlural: "Gambian Dalasi",
    rounding: 0,
    symbol: "D",
    symbolNative: "D",
    type: Type.fiat,
  },
  {
    code: "GNF",
    countries: ["GN"],
    decimalDigits: 0,
    locale: "fr-GN",
    name: "Guinean Franc",
    namePlural: "Guinean francs",
    rounding: 0,
    symbol: "FG",
    symbolNative: "FG",
    type: Type.fiat,
  },
  {
    code: "GTQ",
    countries: ["GT"],
    decimalDigits: 2,
    locale: "es-GT",
    name: "Guatemalan Quetzal",
    namePlural: "Guatemalan quetzals",
    rounding: 0,
    symbol: "GTQ",
    symbolNative: "Q",
    type: Type.fiat,
  },
  {
    code: "GYD",
    countries: ["GY"],
    decimalDigits: 2,
    iconName: "gyd",
    locale: "en",
    name: "Guyanaese Dollar",
    namePlural: "Guyanaese Dollar",
    rounding: 0,
    symbol: "G$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "HKD",
    countries: ["HK"],
    decimalDigits: 2,
    locale: "en-HK",
    name: "Hong Kong Dollar",
    namePlural: "Hong Kong dollars",
    rounding: 0,
    symbol: "HK$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "HNL",
    countries: ["HN"],
    decimalDigits: 2,
    locale: "es-HN",
    name: "Honduran Lempira",
    namePlural: "Honduran lempiras",
    rounding: 0,
    symbol: "HNL",
    symbolNative: "L",
    type: Type.fiat,
  },
  {
    code: "HRK",
    countries: ["HR"],
    decimalDigits: 2,
    name: "Croatian Kuna",
    namePlural: "Croatian kunas",
    rounding: 0,
    symbol: "kn",
    symbolNative: "kn",
    type: Type.fiat,
  },
  {
    code: "HTG",
    countries: ["HT"],
    decimalDigits: 2,
    iconName: "htg",
    name: "Haitian Gourde",
    namePlural: "Haitian Gourde",
    rounding: 0,
    symbol: "G",
    symbolNative: "G",
    type: Type.fiat,
  },
  {
    code: "HUF",
    countries: ["HU"],
    decimalDigits: 0,
    locale: "hu-HU",
    name: "Hungarian Forint",
    namePlural: "Hungarian forints",
    rounding: 0,
    symbol: "Ft",
    symbolNative: "Ft",
    type: Type.fiat,
  },
  {
    code: "IDR",
    countries: ["ID"],
    decimalDigits: 0,
    locale: "id-ID",
    name: "Indonesian Rupiah",
    namePlural: "Indonesian rupiahs",
    rounding: 0,
    symbol: "Rp",
    symbolNative: "Rp",
    type: Type.fiat,
  },
  {
    code: "ILS",
    countries: ["IL", "PS"],
    decimalDigits: 2,
    locale: "he-IL",
    name: "Israeli New Sheqel",
    namePlural: "Israeli new sheqels",
    rounding: 0,
    symbol: "₪",
    symbolNative: "₪",
    type: Type.fiat,
  },
  {
    code: "IMP",
    countries: [],
    decimalDigits: 2,
    name: "Manx pound",
    namePlural: "Manx pounds",
    rounding: 0,
    symbol: "£",
    symbolNative: "£",
    type: Type.fiat,
  },
  {
    code: "INR",
    countries: ["BT", "IN"],
    decimalDigits: 2,
    locale: "hi-IN",
    name: "Indian Rupee",
    namePlural: "Indian rupees",
    rounding: 0,
    symbol: "Rs",
    symbolNative: "₹",
    type: Type.fiat,
  },
  {
    code: "IQD",
    countries: ["IQ"],
    decimalDigits: 0,
    locale: "ar-IQ",
    name: "Iraqi Dinar",
    namePlural: "Iraqi dinars",
    rounding: 0,
    symbol: "IQD",
    symbolNative: "د.ع.‏",
    type: Type.fiat,
  },
  {
    code: "IRR",
    countries: ["IR"],
    decimalDigits: 0,
    name: "Iranian Rial",
    namePlural: "Iranian rials",
    rounding: 0,
    symbol: "IRR",
    symbolNative: "﷼",
    type: Type.fiat,
  },
  {
    code: "ISK",
    countries: ["IS"],
    decimalDigits: 0,
    locale: "is-IS",
    name: "Icelandic Króna",
    namePlural: "Icelandic krónur",
    rounding: 0,
    symbol: "Ikr",
    symbolNative: "kr",
    type: Type.fiat,
  },
  {
    code: "JEP",
    countries: [],
    decimalDigits: 2,
    name: "Jersey pound",
    namePlural: "Jersey pound",
    rounding: 0,
    symbol: "£",
    symbolNative: "£",
    type: Type.fiat,
  },
  {
    code: "JMD",
    countries: ["JM"],
    decimalDigits: 2,
    locale: "en-JM",
    name: "Jamaican Dollar",
    namePlural: "Jamaican dollars",
    rounding: 0,
    symbol: "J$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "JOD",
    countries: ["JO", "PS"],
    decimalDigits: 3,
    locale: "ar-JO",
    name: "Jordanian Dinar",
    namePlural: "Jordanian dinars",
    rounding: 0,
    symbol: "JD",
    symbolNative: "د.أ.‏",
    type: Type.fiat,
  },
  {
    code: "JPY",
    countries: ["JP"],
    decimalDigits: 0,
    locale: "ja-JP",
    name: "Japanese Yen",
    namePlural: "Japanese yen",
    rounding: 0,
    symbol: "¥",
    symbolNative: "￥",
    type: Type.fiat,
  },
  {
    code: "KES",
    countries: ["KE"],
    decimalDigits: 2,
    locale: "ebu-KE",
    name: "Kenyan Shilling",
    namePlural: "Kenyan shillings",
    rounding: 0,
    symbol: "Ksh",
    symbolNative: "Ksh",
    type: Type.fiat,
  },
  {
    code: "KGS",
    countries: ["KG"],
    decimalDigits: 2,
    iconName: "kgs",
    locale: "ky",
    name: "Kyrgystani Som",
    namePlural: "Kyrgystani Som",
    rounding: 0,
    symbol: "KGS",
    symbolNative: "KGS",
    type: Type.fiat,
  },
  {
    code: "KHR",
    countries: ["KH"],
    decimalDigits: 2,
    locale: "km-KH",
    name: "Cambodian Riel",
    namePlural: "Cambodian riels",
    rounding: 0,
    symbol: "KHR",
    symbolNative: "៛",
    type: Type.fiat,
  },
  {
    code: "KMF",
    countries: ["KM"],
    decimalDigits: 0,
    locale: "fr-KM",
    name: "Comorian Franc",
    namePlural: "Comorian francs",
    rounding: 0,
    symbol: "CF",
    symbolNative: "FC",
    type: Type.fiat,
  },
  {
    code: "KPW",
    countries: ["KP"],
    decimalDigits: 2,
    iconName: "kpw",
    locale: "ko",
    name: "North Korean Won",
    namePlural: "North Korean Won",
    rounding: 0,
    symbol: "₩",
    symbolNative: "₩",
    type: Type.fiat,
  },
  {
    code: "KRW",
    countries: ["KR"],
    decimalDigits: 0,
    locale: "ko-KR",
    name: "South Korean Won",
    namePlural: "South Korean won",
    rounding: 0,
    symbol: "₩",
    symbolNative: "₩",
    type: Type.fiat,
  },
  {
    code: "KWD",
    countries: ["KW"],
    decimalDigits: 3,
    locale: "ar-KW",
    name: "Kuwaiti Dinar",
    namePlural: "Kuwaiti dinars",
    rounding: 0,
    symbol: "KD",
    symbolNative: "د.ك.‏",
    type: Type.fiat,
  },
  {
    code: "KYD",
    countries: ["KY"],
    decimalDigits: 2,
    iconName: "kyd",
    locale: "en",
    name: "Cayman Islands Dollar",
    namePlural: "Cayman Islands Dollar",
    rounding: 0,
    symbol: "CI$",
    symbolNative: "$‏",
    type: Type.fiat,
  },
  {
    code: "KZT",
    countries: ["KZ"],
    decimalDigits: 2,
    locale: "kk-Cyrl-KZ",
    name: "Kazakhstani Tenge",
    namePlural: "Kazakhstani tenges",
    rounding: 0,
    symbol: "KZT",
    symbolNative: "тңг.",
    type: Type.fiat,
  },
  {
    code: "LAK",
    countries: ["LA"],
    decimalDigits: 0,
    locale: "lo",
    name: "Laotian Kip",
    namePlural: "Laotian Kip",
    rounding: 0,
    symbol: "₭N",
    symbolNative: "₭‏‏",
    type: Type.fiat,
  },
  {
    code: "LBP",
    countries: ["LB"],
    decimalDigits: 0,
    locale: "ar-LB",
    name: "Lebanese Pound",
    namePlural: "Lebanese pounds",
    rounding: 0,
    symbol: "LB£",
    symbolNative: "ل.ل.‏",
    type: Type.fiat,
  },
  {
    code: "LKR",
    countries: ["LK"],
    decimalDigits: 2,
    locale: "si-LK",
    name: "Sri Lankan Rupee",
    namePlural: "Sri Lankan rupees",
    rounding: 0,
    symbol: "SLRs",
    symbolNative: "SL Re",
    type: Type.fiat,
  },
  {
    code: "LRD",
    countries: ["LR"],
    decimalDigits: 2,
    iconName: "lrd",
    locale: "en",
    name: "Liberian Dollar",
    namePlural: "Liberian Dollar",
    rounding: 0,
    symbol: "LD$",
    symbolNative: "L$",
    type: Type.fiat,
  },
  {
    code: "LSL",
    countries: ["LS"],
    decimalDigits: 2,
    iconName: "lsl",
    name: "Lesotho Loti",
    namePlural: "Lesotho Loti",
    rounding: 0,
    symbol: "L",
    symbolNative: "M",
    type: Type.fiat,
  },
  {
    code: "LTL",
    countries: [],
    decimalDigits: 2,
    name: "Lithuanian Litas",
    namePlural: "Lithuanian litai",
    rounding: 0,
    symbol: "Lt",
    symbolNative: "Lt",
    type: Type.fiat,
  },
  {
    code: "LVL",
    countries: [],
    decimalDigits: 2,
    name: "Latvian Lats",
    namePlural: "Latvian lati",
    rounding: 0,
    symbol: "Ls",
    symbolNative: "Ls",
    type: Type.fiat,
  },
  {
    code: "LYD",
    countries: ["LY"],
    decimalDigits: 3,
    locale: "ar-LY",
    name: "Libyan Dinar",
    namePlural: "Libyan dinars",
    rounding: 0,
    symbol: "LD",
    symbolNative: "د.ل.‏",
    type: Type.fiat,
  },
  {
    code: "MAD",
    countries: ["EH", "MA"],
    decimalDigits: 2,
    locale: "ar-MA",
    name: "Moroccan Dirham",
    namePlural: "Moroccan dirhams",
    rounding: 0,
    symbol: "MAD",
    symbolNative: "د.م.‏",
    type: Type.fiat,
  },
  {
    code: "MDL",
    countries: ["MD"],
    decimalDigits: 2,
    locale: "ro-MD",
    name: "Moldovan Leu",
    namePlural: "Moldovan lei",
    rounding: 0,
    symbol: "MDL",
    symbolNative: "MDL",
    type: Type.fiat,
  },
  {
    code: "MGA",
    countries: ["MG"],
    decimalDigits: 0,
    locale: "fr-MG",
    name: "Malagasy Ariary",
    namePlural: "Malagasy Ariaries",
    rounding: 0,
    symbol: "MGA",
    symbolNative: "MGA",
    type: Type.fiat,
  },
  {
    code: "MKD",
    countries: ["MK"],
    decimalDigits: 2,
    locale: "mk-MK",
    name: "Macedonian Denar",
    namePlural: "Macedonian denari",
    rounding: 0,
    symbol: "MKD",
    symbolNative: "MKD",
    type: Type.fiat,
  },
  {
    code: "MMK",
    countries: ["MM"],
    decimalDigits: 0,
    locale: "my-MM",
    name: "Myanma Kyat",
    namePlural: "Myanma kyats",
    rounding: 0,
    symbol: "MMK",
    symbolNative: "K",
    type: Type.fiat,
  },
  {
    code: "MNT",
    countries: ["MN"],
    decimalDigits: 2,
    iconName: "mnt",
    locale: "mn",
    name: "Mongolian Tugrik",
    namePlural: "Mongolian Tugrik",
    rounding: 0,
    symbol: "₮",
    symbolNative: "₮",
    type: Type.fiat,
  },
  {
    code: "MOP",
    countries: ["MO"],
    decimalDigits: 2,
    locale: "zh-Hans-MO",
    name: "Macanese Pataca",
    namePlural: "Macanese patacas",
    rounding: 0,
    symbol: "MOP$",
    symbolNative: "MOP$",
    type: Type.fiat,
  },
  {
    code: "MRO",
    countries: ["MR"],
    decimalDigits: 2,
    name: "Mauritanian ouguiya",
    namePlural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "UM",
    symbolNative: "UM",
    type: Type.fiat,
  },
  {
    code: "MUR",
    countries: ["MU"],
    decimalDigits: 0,
    locale: "en-MU",
    name: "Mauritian Rupee",
    namePlural: "Mauritian rupees",
    rounding: 0,
    symbol: "MURs",
    symbolNative: "MURs",
    type: Type.fiat,
  },
  {
    code: "MVR",
    countries: ["MV"],
    decimalDigits: 2,
    locale: "dv",
    name: "Maldivian Rufiyaa",
    namePlural: "Maldivian Rufiyaa",
    rounding: 0,
    symbol: "MRf",
    symbolNative: "Rf",
    type: Type.fiat,
  },
  {
    code: "MWK",
    countries: ["MW"],
    decimalDigits: 2,
    iconName: "mwk",
    locale: "en",
    name: "Malawian Kwacha",
    namePlural: "Malawian Kwacha",
    rounding: 0,
    symbol: "MK",
    symbolNative: "MK",
    type: Type.fiat,
  },
  {
    code: "MXN",
    countries: ["MX"],
    decimalDigits: 2,
    locale: "es-MX",
    name: "Mexican Peso",
    namePlural: "Mexican pesos",
    rounding: 0,
    symbol: "MX$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "MYR",
    countries: ["MY"],
    decimalDigits: 2,
    locale: "ms-MY",
    name: "Malaysian Ringgit",
    namePlural: "Malaysian ringgits",
    rounding: 0,
    symbol: "RM",
    symbolNative: "RM",
    type: Type.fiat,
  },
  {
    code: "MZN",
    countries: ["MZ"],
    decimalDigits: 2,
    locale: "pt-MZ",
    name: "Mozambican Metical",
    namePlural: "Mozambican meticals",
    rounding: 0,
    symbol: "MTn",
    symbolNative: "MTn",
    type: Type.fiat,
  },
  {
    code: "NAD",
    countries: ["NA"],
    decimalDigits: 2,
    name: "Namibian Dollar",
    namePlural: "Namibian dollars",
    rounding: 0,
    symbol: "N$",
    symbolNative: "N$",
    type: Type.fiat,
  },
  {
    code: "NGN",
    countries: ["NG"],
    decimalDigits: 2,
    locale: "ha-Latn-NG",
    name: "Nigerian Naira",
    namePlural: "Nigerian nairas",
    rounding: 0,
    symbol: "₦",
    symbolNative: "₦",
    type: Type.fiat,
  },
  {
    code: "NIO",
    countries: ["NI"],
    decimalDigits: 2,
    locale: "es-NI",
    name: "Nicaraguan Córdoba",
    namePlural: "Nicaraguan córdobas",
    rounding: 0,
    symbol: "C$",
    symbolNative: "C$",
    type: Type.fiat,
  },
  {
    code: "NOK",
    countries: ["BV", "NO", "SJ"],
    decimalDigits: 2,
    locale: "no",
    name: "Norwegian Krone",
    namePlural: "Norwegian kroner",
    rounding: 0,
    symbol: "Nkr",
    symbolNative: "kr",
    type: Type.fiat,
  },
  {
    code: "NPR",
    countries: ["NP"],
    decimalDigits: 2,
    locale: "ne-NP",
    name: "Nepalese Rupee",
    namePlural: "Nepalese rupees",
    rounding: 0,
    symbol: "NPRs",
    symbolNative: "नेरू",
    type: Type.fiat,
  },
  {
    code: "NZD",
    countries: ["CK", "NU", "NZ", "PN", "TK"],
    decimalDigits: 2,
    locale: "en",
    name: "New Zealand Dollar",
    namePlural: "New Zealand dollars",
    rounding: 0,
    symbol: "NZ$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "OMR",
    countries: ["OM"],
    decimalDigits: 3,
    locale: "ar-OM",
    name: "Omani Rial",
    namePlural: "Omani rials",
    rounding: 0,
    symbol: "OMR",
    symbolNative: "ر.ع.‏",
    type: Type.fiat,
  },
  {
    code: "PAB",
    countries: ["PA"],
    decimalDigits: 2,
    name: "Panamanian Balboa",
    namePlural: "Panamanian balboas",
    rounding: 0,
    symbol: "B/.",
    symbolNative: "B/.",
    type: Type.fiat,
  },
  {
    code: "PEN",
    countries: ["PE"],
    decimalDigits: 2,
    locale: "es-PE",
    name: "Peruvian Nuevo Sol",
    namePlural: "Peruvian nuevos soles",
    rounding: 0,
    symbol: "S/.",
    symbolNative: "S/.",
    type: Type.fiat,
  },
  {
    code: "PGK",
    countries: ["PG"],
    decimalDigits: 2,
    iconName: "pgk",
    locale: "en",
    name: "Papua New Guinean Kina",
    namePlural: "Papua New Guinean Kina",
    rounding: 0,
    symbol: "K",
    symbolNative: "K",
    type: Type.fiat,
  },
  {
    code: "PHP",
    countries: ["PH"],
    decimalDigits: 2,
    locale: "en-PH",
    name: "Philippine Peso",
    namePlural: "Philippine pesos",
    rounding: 0,
    symbol: "₱",
    symbolNative: "₱",
    type: Type.fiat,
  },
  {
    code: "PKR",
    countries: ["PK"],
    decimalDigits: 0,
    locale: "en-PK",
    name: "Pakistani Rupee",
    namePlural: "Pakistani rupees",
    rounding: 0,
    symbol: "PKRs",
    symbolNative: "₨",
    type: Type.fiat,
  },
  {
    code: "PLN",
    countries: ["PL"],
    decimalDigits: 2,
    locale: "pl-PL",
    name: "Polish Zloty",
    namePlural: "Polish zlotys",
    rounding: 0,
    symbol: "zł",
    symbolNative: "zł",
    type: Type.fiat,
  },
  {
    code: "PYG",
    countries: ["PY"],
    decimalDigits: 0,
    locale: "es-PY",
    name: "Paraguayan Guarani",
    namePlural: "Paraguayan guaranis",
    rounding: 0,
    symbol: "₲",
    symbolNative: "₲",
    type: Type.fiat,
  },
  {
    code: "QAR",
    countries: ["QA"],
    decimalDigits: 2,
    locale: "ar-QA",
    name: "Qatari Rial",
    namePlural: "Qatari rials",
    rounding: 0,
    symbol: "QR",
    symbolNative: "ر.ق.‏",
    type: Type.fiat,
  },
  {
    code: "RON",
    countries: ["RO"],
    decimalDigits: 2,
    locale: "ro-RO",
    name: "Romanian Leu",
    namePlural: "Romanian lei",
    rounding: 0,
    symbol: "RON",
    symbolNative: "RON",
    type: Type.fiat,
  },
  {
    code: "RSD",
    countries: ["RS"],
    decimalDigits: 0,
    locale: "sr-Cyrl-RS",
    name: "Serbian Dinar",
    namePlural: "Serbian dinars",
    rounding: 0,
    symbol: "din.",
    symbolNative: "дин.",
    type: Type.fiat,
  },
  {
    code: "RUB",
    countries: ["RU", "SU"],
    decimalDigits: 2,
    locale: "ru-RU",
    name: "Russian Ruble",
    namePlural: "Russian rubles",
    rounding: 0,
    symbol: "RUB",
    symbolNative: "₽",
    type: Type.fiat,
  },
  {
    code: "RWF",
    countries: ["RW"],
    decimalDigits: 0,
    locale: "fr-RW",
    name: "Rwandan Franc",
    namePlural: "Rwandan francs",
    rounding: 0,
    symbol: "RWF",
    symbolNative: "FR",
    type: Type.fiat,
  },
  {
    code: "SAR",
    countries: ["SA"],
    decimalDigits: 2,
    locale: "ar-SA",
    name: "Saudi Riyal",
    namePlural: "Saudi riyals",
    rounding: 0,
    symbol: "SR",
    symbolNative: "ر.س.‏",
    type: Type.fiat,
  },
  {
    code: "SBD",
    countries: ["SB"],
    decimalDigits: 2,
    iconName: "sbd",
    locale: "en",
    name: "Solomon Islands Dollar",
    namePlural: "Solomon Islands Dollars",
    rounding: 0,
    symbol: "SI$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "SCR",
    countries: ["SC"],
    decimalDigits: 2,
    iconName: "scr",
    locale: "fr",
    name: "Seychellois Rupee",
    namePlural: "Seychellois Rupees",
    rounding: 0,
    symbol: "SRe",
    symbolNative: "SR",
    type: Type.fiat,
  },
  {
    code: "SDG",
    countries: ["SD"],
    decimalDigits: 2,
    locale: "ar-SD",
    name: "Sudanese Pound",
    namePlural: "Sudanese pounds",
    rounding: 0,
    symbol: "SDG",
    symbolNative: "SDG",
    type: Type.fiat,
  },
  {
    code: "SEK",
    countries: ["SE"],
    decimalDigits: 2,
    locale: "sv-SE",
    name: "Swedish Krona",
    namePlural: "Swedish kronor",
    rounding: 0,
    symbol: "Skr",
    symbolNative: "kr",
    type: Type.fiat,
  },
  {
    code: "SGD",
    countries: ["SG"],
    decimalDigits: 2,
    locale: "en-SG",
    name: "Singapore Dollar",
    namePlural: "Singapore dollars",
    rounding: 0,
    symbol: "S$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "SHP",
    countries: ["SH"],
    decimalDigits: 2,
    iconName: "shp",
    locale: "en",
    name: "Saint Helena Pound",
    namePlural: "Saint Helena Pounds",
    rounding: 0,
    symbol: "£",
    symbolNative: "£",
    type: Type.fiat,
  },
  {
    code: "SLL",
    countries: ["SL"],
    decimalDigits: 2,
    iconName: "sll",
    locale: "en",
    name: "Sierra Leonean Leone",
    namePlural: "Sierra Leonean Leone",
    rounding: 0,
    symbol: "Le",
    symbolNative: "Le",
    type: Type.fiat,
  },
  {
    code: "SOS",
    countries: ["SO"],
    decimalDigits: 0,
    locale: "so-SO",
    name: "Somali Shilling",
    namePlural: "Somali shillings",
    rounding: 0,
    symbol: "Ssh",
    symbolNative: "Ssh",
    type: Type.fiat,
  },
  {
    code: "SRD",
    countries: ["SR"],
    decimalDigits: 2,
    iconName: "srd",
    locale: "nl",
    name: "Surinamese Dollar",
    namePlural: "Surinamese Dollar",
    rounding: 0,
    symbol: "$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "STD",
    countries: ["ST"],
    decimalDigits: 2,
    name: "São Tomé and Príncipe dobra",
    namePlural: "São Tomé and Príncipe dobras",
    rounding: 0,
    symbol: "Db",
    symbolNative: "Db",
    type: Type.fiat,
  },
  {
    code: "SVC",
    countries: [],
    decimalDigits: 2,
    iconName: "svc",
    name: "Salvadoran Colón",
    namePlural: "Salvadoran Colón",
    rounding: 0,
    symbol: "₡",
    symbolNative: "₡",
    type: Type.fiat,
  },
  {
    code: "SYP",
    countries: ["SY"],
    decimalDigits: 0,
    locale: "ar-SY",
    name: "Syrian Pound",
    namePlural: "Syrian pounds",
    rounding: 0,
    symbol: "SY£",
    symbolNative: "ل.س.‏",
    type: Type.fiat,
  },
  {
    code: "SZL",
    countries: ["SZ"],
    decimalDigits: 2,
    iconName: "szl",
    name: "Swazi Lilangeni",
    namePlural: "Swazi Lilangeni",
    rounding: 0,
    symbol: "L",
    symbolNative: "E‏",
    type: Type.fiat,
  },
  {
    code: "THB",
    countries: ["TH"],
    decimalDigits: 2,
    locale: "th-TH",
    name: "Thai Baht",
    namePlural: "Thai baht",
    rounding: 0,
    symbol: "฿",
    symbolNative: "฿",
    type: Type.fiat,
  },
  {
    code: "TJS",
    countries: ["TJ"],
    decimalDigits: 2,
    iconName: "tjs",
    locale: "tg",
    name: "Tajikistani Somoni",
    namePlural: "Tajikistani Somoni",
    rounding: 0,
    symbol: "TJS",
    symbolNative: "TJS",
    type: Type.fiat,
  },
  {
    code: "TMT",
    countries: ["TM"],
    decimalDigits: 2,
    iconName: "tmt",
    locale: "tk",
    name: "Turkmenistani Manat",
    namePlural: "Turkmenistani Manat",
    rounding: 0,
    symbol: "T",
    symbolNative: "T‏",
    type: Type.fiat,
  },
  {
    code: "TND",
    countries: ["TN"],
    decimalDigits: 3,
    locale: "ar-TN",
    name: "Tunisian Dinar",
    namePlural: "Tunisian dinars",
    rounding: 0,
    symbol: "DT",
    symbolNative: "د.ت.‏",
    type: Type.fiat,
  },
  {
    code: "TOP",
    countries: ["TO"],
    decimalDigits: 2,
    locale: "to-TO",
    name: "Tongan Paʻanga",
    namePlural: "Tongan paʻanga",
    rounding: 0,
    symbol: "T$",
    symbolNative: "T$",
    type: Type.fiat,
  },
  {
    code: "TRY",
    countries: ["TR"],
    decimalDigits: 2,
    locale: "tr-TR",
    name: "Turkish Lira",
    namePlural: "Turkish Lira",
    rounding: 0,
    symbol: "TL",
    symbolNative: "₺",
    type: Type.fiat,
  },
  {
    code: "TTD",
    countries: ["TT"],
    decimalDigits: 2,
    locale: "en-TT",
    name: "Trinidad and Tobago Dollar",
    namePlural: "Trinidad and Tobago dollars",
    rounding: 0,
    symbol: "TT$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "TWD",
    countries: ["TW"],
    decimalDigits: 2,
    locale: "zh-Hant-TW",
    name: "New Taiwan Dollar",
    namePlural: "New Taiwan dollars",
    rounding: 0,
    symbol: "NT$",
    symbolNative: "NT$",
    type: Type.fiat,
  },
  {
    code: "TZS",
    countries: ["TZ"],
    decimalDigits: 0,
    locale: "asa-TZ",
    name: "Tanzanian Shilling",
    namePlural: "Tanzanian shillings",
    rounding: 0,
    symbol: "TSh",
    symbolNative: "TSh",
    type: Type.fiat,
  },
  {
    code: "UAH",
    countries: ["UA"],
    decimalDigits: 2,
    locale: "uk-UA",
    name: "Ukrainian Hryvnia",
    namePlural: "Ukrainian hryvnias",
    rounding: 0,
    symbol: "₴",
    symbolNative: "₴",
    type: Type.fiat,
  },
  {
    code: "UGX",
    countries: ["UG"],
    decimalDigits: 0,
    locale: "cgg-UG",
    name: "Ugandan Shilling",
    namePlural: "Ugandan shillings",
    rounding: 0,
    symbol: "USh",
    symbolNative: "USh",
    type: Type.fiat,
  },
  {
    code: "USD",
    countries: [
      "AC",
      "AS",
      "BQ",
      "DG",
      "EC",
      "FM",
      "GU",
      "HT",
      "IO",
      "MH",
      "MP",
      "PA",
      "PR",
      "PW",
      "SV",
      "TC",
      "TL",
      "UM",
      "US",
      "VG",
      "VI",
      "ZW",
    ],
    decimalDigits: 2,
    locale: "en-US",
    name: "US Dollar",
    namePlural: "US dollars",
    rounding: 0,
    symbol: "$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "UYU",
    countries: ["UY"],
    decimalDigits: 2,
    locale: "es-UY",
    name: "Uruguayan Peso",
    namePlural: "Uruguayan pesos",
    rounding: 0,
    symbol: "$U",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "UZS",
    countries: ["UZ"],
    decimalDigits: 0,
    locale: "uz-Cyrl-UZ",
    name: "Uzbekistan Som",
    namePlural: "Uzbekistan som",
    rounding: 0,
    symbol: "UZS",
    symbolNative: "UZS",
    type: Type.fiat,
  },
  {
    code: "VEF",
    countries: ["VE"],
    decimalDigits: 2,
    name: "Venezuelan Bolívar",
    namePlural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbolNative: "Bs.F.",
    type: Type.fiat,
  },
  {
    code: "VND",
    countries: ["VN"],
    decimalDigits: 0,
    locale: "vi-VN",
    name: "Vietnamese Dong",
    namePlural: "Vietnamese dong",
    rounding: 0,
    symbol: "₫",
    symbolNative: "₫",
    type: Type.fiat,
  },
  {
    code: "VUV",
    countries: ["VU"],
    decimalDigits: 0,
    iconName: "vuv",
    locale: "bi",
    name: "Vanuatu Vatu",
    namePlural: "Vanuatu Vatu",
    rounding: 0,
    symbol: "VUV",
    symbolNative: "VT",
    type: Type.fiat,
  },
  {
    code: "WST",
    countries: ["WS"],
    decimalDigits: 2,
    iconName: "wst",
    locale: "sm",
    name: "Samoan Tala",
    namePlural: "Samoan Tala",
    rounding: 0,
    symbol: "WS$",
    symbolNative: "T",
    type: Type.fiat,
  },
  {
    code: "XAF",
    countries: ["CF", "CG", "CM", "GA", "GQ", "TD"],
    decimalDigits: 0,
    locale: "fr-CM",
    name: "CFA Franc BEAC",
    namePlural: "CFA francs BEAC",
    rounding: 0,
    symbol: "FCFA",
    symbolNative: "FCFA",
    type: Type.fiat,
  },
  {
    code: "XAG",
    countries: [],
    decimalDigits: 2,
    name: "Silver Ounce",
    namePlural: "Silver Ounces",
    rounding: 0,
    symbol: "XAG",
    symbolNative: "XAG",
    type: Type.metal,
  },
  {
    code: "XAU",
    countries: [],
    decimalDigits: 2,
    name: "Gold Ounce",
    namePlural: "Gold Ounces",
    rounding: 0,
    symbol: "XAU",
    symbolNative: "XAU",
    type: Type.metal,
  },
  {
    code: "XCD",
    countries: ["AG", "AI", "DM", "GD", "KN", "LC", "MS", "VC"],
    decimalDigits: 2,
    iconName: "xcd",
    locale: "en",
    name: "East Caribbean Dollar",
    namePlural: "East Caribbean Dollars",
    rounding: 0,
    symbol: "EC$",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "XDR",
    countries: [],
    decimalDigits: 2,
    locale: "fa-IR",
    name: "Special drawing rights",
    namePlural: "Special drawing rights",
    rounding: 0,
    symbol: "SDR",
    symbolNative: "SDR",
    type: Type.fiat,
  },
  {
    code: "XOF",
    countries: ["BF", "BJ", "CI", "GW", "ML", "NE", "SN", "TG"],
    decimalDigits: 0,
    locale: "fr-BJ",
    name: "CFA Franc BCEAO",
    namePlural: "CFA francs BCEAO",
    rounding: 0,
    symbol: "CFA",
    symbolNative: "CFA",
    type: Type.fiat,
  },
  {
    code: "XPF",
    countries: ["NC", "PF", "WF"],
    decimalDigits: 0,
    iconName: "xpf",
    locale: "fr",
    name: "CFP Franc",
    namePlural: "CFP francs",
    rounding: 0,
    symbol: "CFP",
    symbolNative: "CFP",
    type: Type.fiat,
  },
  {
    code: "YER",
    countries: ["YE"],
    decimalDigits: 0,
    locale: "ar-YE",
    name: "Yemeni Rial",
    namePlural: "Yemeni rials",
    rounding: 0,
    symbol: "YR",
    symbolNative: "ر.ي.‏",
    type: Type.fiat,
  },
  {
    code: "ZAR",
    countries: ["LS", "NA", "ZA", "ZW"],
    decimalDigits: 2,
    locale: "en",
    name: "South African Rand",
    namePlural: "South African rand",
    rounding: 0,
    symbol: "R",
    symbolNative: "R",
    type: Type.fiat,
  },
  {
    code: "ZMK",
    countries: [],
    decimalDigits: 0,
    name: "Zambian Kwacha",
    namePlural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZK",
    symbolNative: "ZK",
    type: Type.fiat,
  },
  {
    code: "ZMW",
    countries: ["ZM"],
    decimalDigits: 0,
    locale: "bem-ZM",
    name: "Zambian Kwacha",
    namePlural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZK",
    symbolNative: "ZK",
    type: Type.fiat,
  },
  {
    code: "ZWL",
    countries: [],
    decimalDigits: 2,
    locale: "en-ZW",
    name: "Zimbabwean dollar",
    namePlural: "Zimbabwean dollars",
    rounding: 0,
    symbol: "ZWL",
    symbolNative: "$",
    type: Type.fiat,
  },
  {
    code: "XPT",
    countries: [],
    decimalDigits: 6,
    name: "Platinum Ounce",
    namePlural: "Platinum Ounces",
    rounding: 0,
    symbol: "XPT",
    symbolNative: "XPT",
    type: Type.metal,
  },
  {
    code: "XPD",
    countries: [],
    decimalDigits: 6,
    name: "Palladium Ounce",
    namePlural: "Palladium Ounces",
    rounding: 0,
    symbol: "XPD",
    symbolNative: "XPD",
    type: Type.metal,
  },
  {
    code: "BTC",
    countries: [],
    decimalDigits: 8,
    name: "Bitcoin",
    namePlural: "Bitcoins",
    rounding: 0,
    symbol: "₿",
    symbolNative: "₿",
    type: Type.crypto,
  },
  {
    code: "ETH",
    countries: [],
    decimalDigits: 18,
    name: "Ethereum",
    namePlural: "Ethereum",
    rounding: 0,
    symbol: "Ξ",
    symbolNative: "Ξ",
    type: Type.crypto,
  },
  {
    code: "BNB",
    countries: [],
    decimalDigits: 8,
    name: "Binance",
    namePlural: "Binance",
    rounding: 0,
    symbol: "BNB",
    symbolNative: "BNB",
    type: Type.crypto,
  },
  {
    code: "XRP",
    countries: [],
    decimalDigits: 6,
    name: "Ripple",
    namePlural: "Ripple",
    rounding: 0,
    symbol: "XRP",
    symbolNative: "XRP",
    type: Type.crypto,
  },
  {
    code: "SOL",
    countries: [],
    decimalDigits: 9,
    name: "Solana",
    namePlural: "Solana",
    rounding: 0,
    symbol: "SOL",
    symbolNative: "SOL",
    type: Type.crypto,
  },
  {
    code: "DOT",
    countries: [],
    decimalDigits: 10,
    name: "Polkadot",
    namePlural: "Polkadot",
    rounding: 0,
    symbol: "DOT",
    symbolNative: "DOT",
    type: Type.crypto,
  },
  {
    code: "AVAX",
    countries: [],
    decimalDigits: 18,
    name: "Avalanche",
    namePlural: "Avalanche",
    rounding: 0,
    symbol: "AVAX",
    symbolNative: "AVAX",
    type: Type.crypto,
  },
  {
    code: "MATIC",
    countries: [],
    decimalDigits: 18,
    name: "Matic Token",
    namePlural: "Matic Tokens",
    rounding: 0,
    symbol: "MATIC",
    symbolNative: "MATIC",
    type: Type.crypto,
  },
  {
    code: "LTC",
    countries: [],
    decimalDigits: 8,
    name: "Litecoin",
    namePlural: "Litecoins",
    rounding: 0,
    symbol: "Ł",
    symbolNative: "Ł",
    type: Type.crypto,
  },
  {
    code: "ADA",
    countries: [],
    decimalDigits: 6,
    name: "Cardano",
    namePlural: "Cardanos",
    rounding: 0,
    symbol: "ADA",
    symbolNative: "ADA",
    type: Type.crypto,
  },
  {
    code: "USDT",
    countries: [],
    decimalDigits: 2,
    name: "Tether",
    namePlural: "Tethers",
    rounding: 0,
    symbol: "USDT",
    symbolNative: "USDT",
    type: Type.crypto,
  },
  {
    code: "USDC",
    countries: [],
    decimalDigits: 2,
    name: "USD Coin",
    namePlural: "USD Coins",
    rounding: 0,
    symbol: "USDC",
    symbolNative: "USDC",
    type: Type.crypto,
  },
  {
    code: "DAI",
    countries: [],
    decimalDigits: 2,
    name: "Dai",
    namePlural: "Dais",
    rounding: 0,
    symbol: "DAI",
    symbolNative: "DAI",
    type: Type.crypto,
  },
  {
    code: "ARB",
    countries: [],
    decimalDigits: 8,
    name: "Arbitrum",
    namePlural: "Arbitrums",
    rounding: 0,
    symbol: "ARB",
    symbolNative: "ARB",
    type: Type.crypto,
  },
  {
    code: "OP",
    countries: [],
    decimalDigits: 8,
    name: "Optimism",
    namePlural: "Optimism",
    rounding: 0,
    symbol: "OP",
    symbolNative: "OP",
    type: Type.crypto,
  },
  {
    code: "VES",
    countries: [],
    decimalDigits: 2,
    name: "Venezuelan Bolívar",
    namePlural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.S.",
    symbolNative: "Bs.S.",
    type: Type.fiat,
  },
  {
    code: "STN",
    countries: [],
    decimalDigits: 2,
    locale: "pt",
    name: "São Tomé and Príncipe dobra",
    namePlural: "dobra",
    rounding: 0,
    symbol: "STN",
    symbolNative: "STN",
    type: Type.fiat,
  },
  {
    code: "MRU",
    countries: [],
    decimalDigits: 2,
    locale: "ar",
    name: "Mauritanian ouguiya",
    namePlural: "ouguiya",
    rounding: 0,
    symbol: "MRU",
    symbolNative: "MRU",
    type: Type.fiat,
  },
];

const currencyCodesInUse: string[] = [
  "AED",
  "ARS",
  "AUD",
  "BRL",
  "BTC",
  "CAD",
  "CHF",
  "CNY",
  "COP",
  "DKK",
  "EGP",
  "EUR",
  "GBP",
  "HKD",
  "ILS",
  "INR",
  "ISK",
  "JOD",
  "JPY",
  "KRW",
  "KWD",
  "MXN",
  "NZD",
  "PHP",
  "RUB",
  "SEK",
  "SGD",
  "TRY",
  "USD",
  "ZAR",
  "BND",
  "IDR",
  "MYR",
  "THB",
  "VND",
];

export const enabledCurrencies: Currency[] = currencies.filter(
  (currency: Currency) => currencyCodesInUse.includes(currency.code)
);
